import React, { useContext } from 'react'
import Card from '../../../common/card/Card'
import Button from '../../../common/button/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { addMemberModalId } from '../Members/form/Utils'
import Micromodal from 'micromodal'
import AddMemberModal from '../Members/form/AddMemberModal'
import { useGroupDashboardContext } from '../GroupDashboardContext'
import { notAllowedUserMembershipStatus } from '../Members/Members/Utils'
import { TeamContext } from '../MenuTabs/MenuTabs'

const MemberCard = ({ membersCount = 0, teamType, teamURL = [], userMembershipStatus = '', isAdmin, remainingSeats = 0, seatCount, membersModalOption }) => {

  const params = useParams()
  const teamId = params.team_id
  const navigate = useNavigate()
  const memberModalId = addMemberModalId(teamId)
  const { setSelectedAddMemberModal, filtersData } = useGroupDashboardContext()
  const { teamData } = useContext(TeamContext)

  const handleManageMembers = () => {
    navigate(`/organization/${teamId}/members`)
  }
  
  const handleAddMember = () => {
    if ( teamType === 'wooteams' ) {
      setSelectedAddMemberModal({
        teamId: teamId,
        remainingSeats: remainingSeats,
        seatCount: seatCount,
        teamType: teamType
      })
    } else if ( teamType === 'msynclicenses' ) {
      setSelectedAddMemberModal({
        teamId: teamId,
        teamType: teamType
      })
    }
    Micromodal.show(memberModalId)
  }
  
  return (
    <Card className="msync-card--is-style-inline">
      <div className="msync-card__body">
        <div className='msync-title msync-title--is-level-3'>Members</div>
        <p className='msync-group-buttons-description'>{ filtersData.home?.panel_members_description }</p>
        <span className='msync-group-buttons-total-label'>
          Total members:
          <span className='msync-group-buttons-total-content'> { membersCount } </span>
        </span>
      </div>
      <div class="msync-card__footer msync-flex msync-flex--density-8">
        <Button
          className="msync-button--is-style-outline"
          onClick={()=>handleManageMembers()}
        >
          Manage Members
        </Button>
        {
          ( teamData.can_add_members || teamType !== 'msynclicenses' ) && ( notAllowedUserMembershipStatus.includes(userMembershipStatus) 
          ? <Button isDisabled>
              Add Member
            </Button>
          : <>
              <Button
                onClick={()=>handleAddMember()}
              >
                Add Member
              </Button>
              <AddMemberModal 
                isAdmin={ isAdmin } 
                modalOption={ membersModalOption } 
                teamId={ teamId }
                navigateTo={`/organization/${teamId}/members`}
              />
            </> )
        }
      </div>
    </Card>
  )
}

export default MemberCard
